import { Suspense } from "react";

import Dim from "@/components/shared/ui/Dim/Dim";
import Loader from "@/components/shared/ui/Loader/Loader";
import { setDealTypeDisplayName } from "@utils/returnDealTypeDisplayName/returnDealTypeDisplayName";

import Pagination from "./components/Pagination/Pagination";
import PatentTable from "./components/PatentTable/PatentTable";
import PatentTableFilter from "./components/PatentTableFilter/PatentTableFilter";
import { useSetScrollPosition } from "./hooks/useSetScrollPosition";
import * as S from "./PatentContainer.style";

const PatentContainer = () => {
  useSetScrollPosition();
  setDealTypeDisplayName();

  return (
    <S.PatentListWrapper>
      <Suspense
        fallback={
          <Dim>
            <Loader />
          </Dim>
        }
      >
        <PatentTableFilter />
        <PatentTable />
        <Pagination />
      </Suspense>
    </S.PatentListWrapper>
  );
};

export default PatentContainer;
